// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-3fe857a2] {\n  --magic-box-background: #2f3131;\n}\n\n.action--half[data-v-3fe857a2] {\n  margin-bottom: calc(16px * -1);\n}", ""]);
// Exports
module.exports = exports;
